import { forwardRef } from 'react';

/**
 * UiFileInput — Shared styled file input component
 *
 * Replicates the "Choose File" UI from UploadIneligibleVendorList:
 * - Styled file button with rounded-full, blue theme
 * - Consistent sizing and disabled states
 *
 * Used in: InvoiceOnDemand, UploadIneligibleVendorList
 */

export interface UiFileInputProps {
  /** Accepted file types, e.g. ".csv" */
  accept?: string;
  /** File selection handler */
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  /** Disables the input */
  disabled?: boolean;
  /** Allow multiple file selection */
  multiple?: boolean;
  /** Input name attribute */
  name?: string;
  /** Extra Tailwind classes on the wrapper */
  className?: string;
}

export const UiFileInput = forwardRef<HTMLInputElement, UiFileInputProps>(
  ({ accept, onChange, disabled = false, multiple = false, name, className = '' }, ref) => (
    <input
      ref={ref}
      type='file'
      accept={accept}
      name={name}
      multiple={multiple}
      onChange={onChange}
      disabled={disabled}
      className={`block w-full text-lg text-[#555] file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-lg file:font-semibold file:bg-angular-bg-light file:text-angular-blue hover:file:bg-angular-bg-striped disabled:opacity-50 disabled:cursor-not-allowed ${className}`.trim()}
    />
  )
);

UiFileInput.displayName = 'UiFileInput';
